import useGetDeliveryLocation from '../../modules/mobile/common/hooks/useGetDeliveryLocation';
import { franchisesApiSlice, useLazyGetDeliveryCompatibleCompaniesQuery } from '../../store/api-slices';
import { useSelector } from 'react-redux';
import { selectFranchiseId } from '../../store/slices/InitialDataSlice';
import { DeliveryAddressSchema } from '../../modules/mobile/modals/delivery-address/form/schema';
import { useLocationData } from './provider/LocationDataProvider';
import { GooglePlaceResource } from '../../services/resources/GooglePlaceResource';
import { useFormContext } from 'react-hook-form';
import { ORDER_METHODS } from '../../services/exports/Constants';

const useDeliveryCompatibleStuff = () => {
  const deliveryAddressForm = useFormContext<DeliveryAddressSchema>();
  const { company, orderMethod } = useLocationData();
  const [getDeliveryCompatibleCompanies] = useLazyGetDeliveryCompatibleCompaniesQuery();
  const franchiseId = useSelector(selectFranchiseId);
  const { getLocation, loading, validationError, resetError } = useGetDeliveryLocation(company);
  const deliveryFormValues = deliveryAddressForm.watch();
  const queryState = useSelector(
    franchisesApiSlice.endpoints.getDeliveryCompatibleCompanies.select({
      franchiseId,
      latitude: deliveryFormValues.delivery_lat,
      longitude: deliveryFormValues.delivery_lng,
      street_name: deliveryFormValues.delivery_street_name,
      street_number: deliveryFormValues.delivery_street_number,
      city: deliveryFormValues.delivery_city,
      zip_code: deliveryFormValues.delivery_zip_code,
    }),
  );
  const submitHandler = async (data: DeliveryAddressSchema, selectedPlace?: GooglePlaceResource) => {
    const { location, success } = await getLocation(data, selectedPlace);

    if (!success) {
      return;
    }

    deliveryAddressForm.setValue('delivery_lat', location.lat());
    deliveryAddressForm.setValue('delivery_lng', location.lng());

    if (orderMethod !== ORDER_METHODS.DELIVERY) {
      return;
    }

    await getDeliveryCompatibleCompanies(
      {
        franchiseId,
        latitude: location.lat(),
        longitude: location.lng(),
        street_name: data.delivery_street_name,
        street_number: data.delivery_street_number,
        city: data.delivery_city,
        zip_code: data.delivery_zip_code,
      },
      true,
    );
  };
  const handle = (selectedPlace?: GooglePlaceResource) =>
    deliveryAddressForm?.handleSubmit((data) => submitHandler(data, selectedPlace))();

  return { handle, queryState, isLoading: loading || queryState.isLoading, validationError, resetError };
};

export default useDeliveryCompatibleStuff;
